module.exports = __webpack_public_path__ + "img/4C240E_A5613B_895134_734C44-256px.ac6ac016.png";